import IconComponent from "icons/IconComponent";

import YelpIcon from "./yelp-icon.svg";

export default (YelpIcon as any) as IconComponent;
